const autoNgTemplateLoaderTemplate1 = require('./volume.html');

angular.module('portainer.kubernetes').component('kubernetesVolumeView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesVolumeController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
    endpoint: '<',
  },
});
